var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector38(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H9C6.79 0 5 1.79 5 4V14C5 14.55 5.45 15 6 15H18C18.55 15 19 14.55 19 14V4C19 1.79 17.21 0 15 0ZM14.71 9.29C15.1 9.68 15.1 10.31 14.71 10.7C14.51 10.9 14.26 10.99 14 10.99C13.74 10.99 13.49 10.89 13.29 10.7L12 9.41L10.71 10.7C10.51 10.9 10.26 10.99 10 10.99C9.74 10.99 9.49 10.89 9.29 10.7C8.9 10.31 8.9 9.68 9.29 9.29L10.58 8L9.29 6.71C8.9 6.32 8.9 5.69 9.29 5.3C9.68 4.91 10.31 4.91 10.7 5.3L11.99 6.59L13.28 5.3C13.67 4.91 14.3 4.91 14.69 5.3C15.08 5.69 15.08 6.32 14.69 6.71L13.4 8L14.69 9.29H14.71ZM24 14V16C24 18.21 22.21 20 20 20H4C1.79 20 0 18.21 0 16V14C0 12.14 1.28 10.59 3 10.14V14C3 15.65 4.35 17 6 17H18C19.65 17 21 15.65 21 14V10.14C22.72 10.59 24 12.14 24 14Z",
    fill: "#234492"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector38);
export default __webpack_public_path__ + "static/media/Vector (38).9260d02e62a87f3a5c20376c9fcf66c8.svg";
export { ForwardRef as ReactComponent };